import type { Book } from "@book-club/shared";
import booksService from "@/features/books/services/booksService";

/**
 * Checks for duplicate books using provided values
 * Returns the duplicate book if found and showProceedAnyway is false, otherwise returns null
 * Only used in "add" mode
 */
export async function checkForDuplicateBook(
    isbn: string | undefined,
    title: string | undefined,
    author: string | undefined,
    showProceedAnyway: boolean
): Promise<Book | null> {
    if ((title && author) || isbn) {
        try {
            const duplicate = await booksService.checkDuplicateBook(isbn, title, author);
            return duplicate && !showProceedAnyway ? duplicate : null;
        } catch {
            // Ignore errors in duplicate check (non-blocking)
            return null;
        }
    }
    return null;
}
